module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6e61fa7e48326bd2026d28e7a62884b1.svg";